import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useUserInfoStore } from "@/stores/userInfoStore";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import NewGameButtonsView from "@/views/home/NewGameButtonsView.vue";
import { useGameStore } from "@/stores/gameStore";
import ShowErrorLoading from "@/views/ShowErrorLoading.vue";
import { createNewGame, findOpenGame } from "@/firebase/database";
import GameRulesView from "@/views/home/gameRulesView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePresenter',
  setup(__props) {

const userInfoStore = useUserInfoStore();
const { loggedIn, uid } = storeToRefs(userInfoStore);
const gameStore = useGameStore();
const { waitingMessage, error } = storeToRefs(gameStore);

const router = useRouter();

waitingMessage.value = "";
error.value = null;

function randomGamePressedHandler() {
  if (!loggedIn.value) {
    console.log("user not logged in...");
    return;
  }
  waitingMessage.value = "Looking for a random game...";
  findOpenGame(uid.value)
    .then((gameId) => {
      if (gameId == null) {
        waitingMessage.value = "Waiting for an opponent...";
        return createNewGame(uid.value, true);
      }
      return gameId;
    })
    .then((gameId) => {
      waitingMessage.value = "";
      router.push({ name: "game", params: { id: gameId } });
    });
}

function friendGamePressedHandler() {
  if (!loggedIn.value) {
    console.log("user not logged in...");
    return;
  }
  waitingMessage.value = "Creating new game...";
  createNewGame(uid.value, false).then((gameId) => {
    waitingMessage.value = "";
    if (gameId == null) return;
    router.push({ name: "game", params: { id: gameId } });
  });
}

function localGamePressed() {
  router.push({ name: "game", params: { id: "local" } });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ShowErrorLoading, {
      "waiting-message": _unref(waitingMessage),
      error: _unref(error)
    }, null, 8, ["waiting-message", "error"]),
    (!_unref(waitingMessage))
      ? (_openBlock(), _createBlock(NewGameButtonsView, {
          key: 0,
          "is-logged-in": _unref(loggedIn),
          onRandomGamePressed: randomGamePressedHandler,
          onFriendGamePressed: friendGamePressedHandler,
          onLocalGamePressed: localGamePressed
        }, null, 8, ["is-logged-in"]))
      : _createCommentVNode("", true),
    _createVNode(GameRulesView)
  ], 64))
}
}

})